module.exports = __webpack_public_path__ + "img/menu.5631d376.png";